import React from 'react'
import { connect } from 'react-redux'
import NumericKeyBoard from '../../components/NumericKeyBoard'
import { getTranslation } from '../../actions/dataActions'
import { setPagerNumber } from '../../actions/receiptActions'
import * as resource from '../../constants/Resources'
import { setGroup } from '../../actions/layoutActions'
import { setMessageModal } from '../../actions/generalActions'

function SelectPagerButton(props) {
    const { width, height, top, left, pagerNumber, setPagerNumber, getTranslation, keylayoutgroupid, setGroup, setMessageModal } = props;
    let style = {
        width: `${width}%`,
        height: `${height}%`,
        top: `${top}%`,
        left: `${left}%`,
        fontSize: `20px`,
    };

    const handleOk = (value) => {
        setPagerNumber(value === '' ? null : value);
        if (keylayoutgroupid > 0) {
            if (value !== '' && value !== null) {
                setGroup(keylayoutgroupid);
            } else {
                setMessageModal(true, getTranslation(resource.INVALID_PAGER_MESSAGE));
            }
        }
    };

    const handleCancel = () => {
        setPagerNumber(null);
    };

    return (
        <div style={style} className="selectPager">
            <div className="selectPager_header">
                <div className="header_top">
                    {getTranslation(resource.SELECT_PAGER)}
                </div>
            </div>
            <div className="selectPager_content">
                <NumericKeyBoard
                    open={true}
                    initialValue={pagerNumber}
                    onOk={handleOk}
                    onCancel={handleCancel}
                />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        pagerNumber: state.receiptState.receipt.pagerNumber != null ? state.receiptState.receipt.pagerNumber : '',
        keylayoutgroupid: state.layoutState.paymentkeygroupid,
    }
}

export default connect(mapStateToProps, {
    getTranslation,
    setPagerNumber,
    setGroup,
    setMessageModal
})(SelectPagerButton)


// WEBPACK FOOTER //
// src/freeformat/components/SelectPagerButton.jsx